import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store/index.js'
import illusroutes from './routes/routes-illustrators.js'
import animroutes from './routes/routes-animators.js'
import ixr from '@/components/navigation/ixrouter.js'


Vue.use(Router)

function fulfillScroll(savedPosition){
  store.commit('setRequestedScrollY', 0)
  return savedPosition;
}

async function locateArtistPage(url, next) {
  console.log('locate artist url', url)
  const artists = await store.dispatch('fetchArtists')
  if(url === 'contact') {
    next('/contact/' + store.state.lang.toLowerCase())
    return
  }
  let ul = url.toLowerCase()
  for(let artist of artists) {
    if(ul === artist.portfolio_url.toLowerCase()){
      if(artist.illustrator) {
        next(ixr.getPushPath('/artists/' + artist.portfolio_url))
        return
      }
      else {
        next(ixr.getPushPath('/animators/' + artist.portfolio_url))
        return
      }
    }
  }
  
  window.location = '/not-found'
}


export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Home,
      children: illusroutes
    },
    {
      path: '/animated',
      redirect: {
        name: 'animation style gallery',
        params: {
          url: 'animated-(animated-by-others)'
        }
      }
    },
    {
      path: '/animation',
      component: () => import(/* webpackChunkName: "animation" */ '@/views/AnimationNav.vue'),
      children: animroutes
    },
    {
      path: '/artist-image-list/:name',
      name: 'artist image list ssr',
      component: () => import(/* webpackChunkName: "seo" */'@/views/ssr/ArtistImageList.vue'),
      props: true
    },
    {
      path: '/weeklyportfolio',
      beforeEnter: async (to, from, next) => {
        let ret = await store.dispatch('fetchSetting', 'weekly')
        console.log('weekly is ', ret)
        next(ret)
      }
    },
    {
      path: '/*',
      name: 'catch-all',
      beforeEnter: (to, from, next) => {
        console.log('going to', to)
        if(to.params.pathMatch) {
          locateArtistPage(to.params.pathMatch, next)
        }
        else {
          //next('/not-found')
          window.location = '/not-found'
        }
        
      }
    }
  ],
  
  scrollBehavior (to, from, savedPosition) {
    if(to.name && from.name) {
      if(from.name.startsWith('news')){
        if(to.name.startsWith('news')) {
          return
        }
      }
      else if(from.name.startsWith('video')){
        if(to.name.startsWith('video')) {
          return
        }
      }
      else if(to.name.indexOf('home page') > 0) {
        return { x: 0, y: 0 }
      }
      else if(to.name === 'about us') {
        return { x: 0, y: 0 }
      }
    }
    if(!savedPosition) {
      return { x: 0, y: 0 }
    }
    else {
      store.commit('setRequestedScrollY', savedPosition.y)
      
      
      return new Promise((resolve, reject) => {
        try {
          setTimeout(() => {
            resolve(fulfillScroll(savedPosition))
          }, 50)
        }
        catch(error) {
          reject('Unable to set timeout')
        }
      })
      
      
    }
  }
})
